let acc = document.getElementsByClassName("contentAccordion");
let i;

for (i = 0; i < acc.length; i++) {
	acc[i].addEventListener("click", function () {
		if (this.classList.contains('active')) {
			this.classList.remove("active");
			let panel = this.nextElementSibling;
			panel.style.maxHeight = null;
		} else {
			this.classList.toggle("active");
			let panel = this.nextElementSibling;
			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
				panel.style.margin = null;
			} else {
				panel.style.maxHeight = panel.scrollHeight + "px";
				// panel.style.margin = '16px 0px';
			}
		}
	});
}
